import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { getReports } from 'src/store/ducks/reports/actions'
import { PageHeader } from 'src/components/Ant'
import { Report, ReportType } from 'src/store/ducks/reports/types'
import useDocumentTitle from 'src/hooks/use-document-title'

import { WrapTable, WrapAlert } from './styles'
import ReportParametersModal from './components/report-parameters-modal'
import TableList from './components/table-list'

function Reports() {
  const dispatch = useDispatch()
  const {
    reports: { loading, reportsList, error },
    me: {
      user: { tenant_id }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports,
    me: state.me
  }))
  const [visibleModal, setVisibleModal] = useState<boolean>(false)
  const [activeReport, setActiveReport] = useState<Report>(null)

  useDocumentTitle('web.reports.title')
  function toggleModal() {
    setVisibleModal(!visibleModal)
  }

  useEffect(() => {
    dispatch(getReports())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dataSource: Report[] = useMemo(() => {
    if (!loading && !error && reportsList.length > 0) {
      return reportsList
        .filter(({ report_type }) => report_type === ReportType.REPORT)
        .filter(
          ({ report_data_id }) =>
            report_data_id !== 15 || tenant_id === 559042084949
        )
        .sort(({ report_data_id: a }, { report_data_id: b }) => a - b)
    }
  }, [error, reportsList, loading, tenant_id])

  return (
    <>
      <PageHeader title="web.reports.title" />
      {error ? (
        <WrapAlert message="web.reports.load-error" />
      ) : (
        <>
          <WrapTable>
            <TableList
              dataSource={dataSource}
              loading={loading || false}
              onRow={(report: Report) => ({
                onClick: () => {
                  toggleModal()
                  setActiveReport(report)
                }
              })}
              pagination={false}
            />
          </WrapTable>
          <ReportParametersModal
            activeReport={activeReport}
            toggleModal={toggleModal}
            visibleModal={visibleModal}
          />
        </>
      )}
    </>
  )
}

export default Reports
